import '@styles/frontend/main.scss';
import { renderForm } from './render';

export { setSubmitListeners } from './submit';

export const initLeadForms = (formsUrl = 'https://aquentllc.wpengine.com/') => {
  const renderFormElements = () => {
    const forms = document.querySelectorAll('div[data-leadform-id]:not([data-rendered])');
    const trimmedFormsUrl = formsUrl.replace(/\/$/, ''); // Remove the trailing slash
    if (forms.length > 0) {
      forms.forEach((form) => {
        const formId = form.getAttribute('data-leadform-id') ?? 0;
        form.setAttribute('data-rendered', 'true');
        renderForm(form, formId, trimmedFormsUrl);
      });
    }
  };

  renderFormElements();

  const observer = new MutationObserver(renderFormElements);
  const config = { attributes: false, childList: true, subtree: true };
  observer.observe(document.body, config);
};

initLeadForms(window.leadFormsUrl ?? 'https://aquentllc.wpengine.com/');
